import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    search: builder.mutation({
      query(req) {
        return {
          url: urls.search,
          method: 'POST',
          data: req,
        };
      },
    }),
    // get allowed search types
    activeTypes: builder.query({
      query: () => ({
        url: urls.searchActiveTypes,
      }),
    }),
    runReindexDatabase: builder.mutation({
      query() {
        return {
          url: `${urls.searchAdminRunDatabaseImport}`,
          method: 'POST',
          data: {},
        };
      },
    }),
    runReindexFiles: builder.mutation({
      query() {
        return {
          url: `${urls.searchAdminRunFileImport}`,
          method: 'POST',
          data: {},
        };
      },
    }),
    getAllSearchTypes: builder.query({
      query: () => ({
        url: urls.searchAdminAllTypes,
      }),
    }),
    activateDeactivateType: builder.mutation({
      query(req) {
        return {
          url: `${urls.searchAdminActivateDeactivateType}`,
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const {
  useSearchMutation,
  useActiveTypesQuery,
  useRunReindexDatabaseMutation,
  useRunReindexFilesMutation,
  useGetAllSearchTypesQuery,
  useActivateDeactivateTypeMutation,
} = searchApi;
